import { useCallback, useMemo } from "react";
import axios from "axios";

export const useVoiceHandler = ({ apiConfig }) => {
  // 創建一個記憶化的 axios 實例，避免重複創建
  const apiClient = useMemo(() => {
    return axios.create({
      baseURL: apiConfig.SERVER_URL,
      headers: {
        "x-api-key": apiConfig.API_KEY,
      },
    });
  }, [apiConfig.SERVER_URL, apiConfig.API_KEY]);

  // 處理表單數據建立的輔助函數
  const createFormData = useCallback((blob, payload) => {
    const formData = new FormData();

    // 處理 payload 添加到 formData
    Object.entries(payload).forEach(([key, value]) => {
      // 特殊處理 speech_keywords 陣列
      if (
        key === "speech_keywords" &&
        Array.isArray(value) &&
        value.length > 0
      ) {
        value.forEach((keyword) => {
          formData.append(key, keyword);
        });
      } else if (value !== undefined && value !== null) {
        // 只添加有效值
        formData.append(key, value);
      }
    });

    // 添加音頻文件
    formData.append("file", blob, `voice_${Date.now()}.mp3`);

    return formData;
  }, []);

  const sendVoiceMessage = useCallback(
    async (blob, config = {}) => {
      // 允許請求被取消
      const abortController = new AbortController();

      // 使用自定義或默認的 payload
      const defaultPayload = {
        chat_type: "ai",
        web_search: false,
        tts: true,
        temperature: 0.7,
        channel_type: "web",
        speech_keywords: [],
        blob_ids: "",
        asr_service: apiConfig.ASR_SERVICE,
      };

      // 合併配置，保持正確的優先級順序
      const payload = {
        ...defaultPayload,
        ...apiConfig.voicePayload,
        ...config?.payload,
      };

      const formData = createFormData(blob, payload);

      try {
        const response = await apiClient.post(
          `/private/chatrooms/chat/ai/${apiConfig.CHATROOM_ID}/speech`,
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              ...config?.headers,
            },
            params: {
              ...apiConfig.voiceParams,
              ...config?.params,
            },
            signal: abortController.signal,
          },
        );
        return response.data;
      } catch (error) {
        if (axios.isCancel(error)) {
          throw new Error("語音請求已取消");
        }
        console.error("語音請求錯誤:", error);
        throw new Error(`傳送語音錯誤: ${error.message || "未知錯誤"}`);
      }
    },
    [apiClient, apiConfig, createFormData],
  );

  return {
    sendVoiceMessage,
  };
};
